import React from "react";
import { useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";

const RedirectingPage = () => {
  useEffect(() => {
    if (isAndroid) {
      const url =
        "intent://instagram.com/#Intent;scheme=https;package=com.instagram.android;end";

      window.location.replace(url);
    } else if (isIOS) {
      window.location.replace("instagram://");

      setTimeout(() => {
        window.location.replace(
          "https://apps.apple.com/us/app/instagram/id389801252"
        );
      }, 10000);
    } else {
      window.location.replace(process.env.REACT_APP_FRONTEND_URL);
    }
  }, []);

  return (
    <div className="App">
      <div>
        If you have not been automatically redirected, click on the following
        link:
      </div>
      {isAndroid ? (
        <a href="https://play.google.com/store/apps/details?id=com.instagram.android">
          Open Android app
        </a>
      ) : isIOS ? (
        <a href="https://apps.apple.com/us/app/instagram/id389801252">
          Open iOS app
        </a>
      ) : (
        <a href={process.env.REACT_APP_FRONTEND_URL}>Open Web app</a>
      )}
    </div>
  );
};

export default RedirectingPage;
